import * as React from "react";
import { FormItemProps } from "antd/lib/form/FormItem";
import { WrappedFormUtils } from "antd/lib/form/Form";
import "./PbrInputTextArea.scss";
import { PbrFormItem } from "../PbrFormItem/PbrFormItem";
import TextArea, { TextAreaProps } from "antd/lib/input/TextArea";

export interface IPbrInputTextAreaProps extends TextAreaProps {
  name: string;
  error?: boolean;
  rules?: any[];
  formWrapper?: WrappedFormUtils;
  formItemProps?: FormItemProps;
}

export class PbrInputTextArea extends React.Component<IPbrInputTextAreaProps> {
  public render() {
    const getFieldDecorator = this.props.formWrapper ? this.props.formWrapper.getFieldDecorator : null;
    const props = { ...this.props };
    const formItemProsp = this.props.formItemProps;
    const value = props.value;

    delete props.value;
    delete props.formWrapper;
    delete props.formItemProps;

    return (
      <PbrFormItem {...formItemProsp} className={`pbr-standard-input ${this.props.className ?? ''}`}>
        {(getFieldDecorator && getFieldDecorator(props.name, { rules: props.rules, initialValue: value })(<TextArea {...props} />)) || <TextArea {...props} />}
      </PbrFormItem>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/common/PbrInputTextArea/PbrInputTextArea.tsx